(ns frontend.view.nev.kyc.process-status-views.draft-status
  (:require
   [common.languages :as languages]
   [common.localization :as loc]
   [frontend.actions.entity :as entity-actions]
   [frontend.actions.kyc-process :as kyc-process-actions]
   [ui.dom-globals :as dg]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
   [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
   [ui.components.button.view :as button]
   [frontend.view.nev.kyc.process.pdf-make-utils :as pdf-make-utils]
   [frontend.state.current-session :as session]))

(defn view
  [state-atom _local-atom entity save! loading-atom field-errors-atom]
  (let [lang (:kyc-process/language entity)
        lang-kw (languages/long->short lang)
        board-members (some-> entity
                              :kyc-process/answers
                              :kyc-legal-entity/board-members-edn)
        unconfirmed-board-members? (some->> board-members
                                            (some (fn [bm]
                                                    (= (:kyc-board-member/confirmation-status bm)
                                                       :pending))))
        field-errors? (seq @field-errors-atom)]
    [edit-view/view
     {:state-atom      state-atom
      :loading-atom    loading-atom
      :save!           save!
      :entity          entity
      :mandatory?      false
      :read-only?      false
      :lang            :en
      :field-errors-atom field-errors-atom
      :footer-renderer (fn [_state-atom _answers-atom entity _invalid-questions]
                         [:div.d-flex.flex-static.kyc-submit-footer
                          [:div.container
                           [:div.d-flex.justify-content-between
                            [:div.d-flex
                             [fu/tooltip (loc/tr :kyc-exit-tooltip nil lang-kw)
                              [kvu/exit-button entity :en]]]

                            ;; This is fine because during development we need to debug the pdf printing before all mandatory fields are filled
                            (when (session/dev?)
                              [:<>
                               [button/sm-secondary-hollow
                                {:on-click (fn []
                                             (pdf-make-utils/save-as-pdf! {:entity entity
                                                                           :state-atom state-atom}))}
                                (loc/tr :save-as-pdf nil lang)]
                               [button/sm-secondary-hollow
                                {:on-click (fn []
                                             (pdf-make-utils/save-as-pdf! {:entity entity
                                                                           :state-atom state-atom
                                                                           :e-sign-version? true}))}
                                "Save as pdf (esign version)"]])

                            [:div
                             {:class "flex flex-row gap-2"}
                             [button/danger-solid
                              {:on-click (fn [_]
                                           (entity-actions/*->disable! (:db/id entity)
                                                                       (fn [_resp]
                                                                         (dg/history-back))
                                                                       (fn [resp]
                                                                         (logging/error
                                                                          "Failed to complete KYC "
                                                                          resp))))}
                              (loc/tr :delete-draft)]
                             [button/primary-solid
                              {:disabled? (or field-errors?
                                              unconfirmed-board-members?)
                               :tooltip   (cond
                                            field-errors?
                                            (loc/tr :fix-form-errors-to-continue nil lang-kw)

                                            unconfirmed-board-members?
                                            (loc/tr :confirm-board-members-to-continue nil lang-kw))
                               :on-click  (fn [_]
                                            (kyc-process-actions/*->prefilled
                                             {:kyc-process-id (:db/id entity)}
                                             (fn [_resp])
                                             (fn [resp]
                                               (logging/error "Failed to complete KYC " resp))))}
                              (loc/tr :continue)]]]]])}]))
